/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from '../models/User';
import type { UserPatch } from '../models/UserPatch';
import type { UserPost } from '../models/UserPost';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminUsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all users.
     * @returns User Default Response
     * @throws ApiError
     */
    public getUsers(): CancelablePromise<Array<User>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/users/',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Create a user.
     * @param requestBody
     * @returns User Default Response
     * @throws ApiError
     */
    public postUser(
        requestBody: UserPost,
    ): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/users/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Fetch user details.
     * @param id
     * @returns User Default Response
     * @throws ApiError
     */
    public getUser(
        id: number,
    ): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Default Response`,
            },
        });
    }
    /**
     * Update a user.
     * @param id
     * @param requestBody
     * @returns User Default Response
     * @throws ApiError
     */
    public patchUser(
        id: number,
        requestBody: UserPatch,
    ): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/admin/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Update a user.
     * @param id
     * @param requestBody
     * @returns User Default Response
     * @throws ApiError
     */
    public putUser(
        id: number,
        requestBody: UserPost,
    ): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/admin/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Delete a user.
     * @param id
     * @returns any Default Response
     * @throws ApiError
     */
    public deleteUser(
        id: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Default Response`,
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
}
